import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MatInputModule} from '@angular/material/input';
import {BrowserModule} from '@angular/platform-browser';
import {MatButtonModule} from '@angular/material/button';

import {WorkflowComponent} from './workflow.component';
import {MatSelectModule} from '@angular/material/select';
import {WorkflowNaviBarComponent} from './workflow-navi-bar/workflow-navi-bar.component';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppRoutingModule} from '../app-routing.module';
import { WorkflowValidationUploadComponent } from './workflow-validation-upload/workflow-validation-upload.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
//import { TranslateModule } from '@ngx-translate/core';
import {SharedModule} from "../shared/shared.module";
import { FileuploadModule } from '../fileupload/fileupload.module';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { FileSizeModule } from 'ngx-filesize';
import { MatDialogModule } from '@angular/material/dialog';
import { AcceptDeclineDialogComponent } from "../dialog/accept-decline-dialog/accept-decline-dialog.component";
import { MessageDialogComponent } from "../dialog/message-dialog/message-dialog.component";
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from "@angular/material";
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SuccessMessageToastComponent } from "../toast/success-message-toast/success-message-toast.component";
import { MatGridListModule } from '@angular/material/grid-list';
import { WorkflowStepDriversManualModule } from "./workflow-step-drivers-manual/workflow-step-drivers-manual.module";
import { WorkflowStepAppAssetsModule } from "./workflow-step-app-assets/workflow-step-app-assets.module";
import { WorkflowStepDisclaimerModule } from "./workflow-step-disclaimer/workflow-step-disclaimer.module";
import {WorkflowHotspotCreatorModule} from "./workflow-hotspot-creator/workflow-hotspot-creator.module";
import {SuccessSaveToastComponent} from '../toast/success-save-toast/success-save-toast.component';
import {SaveHotspotTemplateNoRowToastComponent} from '../toast/save-hotspot-template-no-row-toast/save-hotspot-template-no-row-toast.component';

@NgModule({
    declarations: [
        WorkflowComponent,
        WorkflowNaviBarComponent,
        WorkflowValidationUploadComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatTabsModule,
        AppRoutingModule,
        MatStepperModule,
        ReactiveFormsModule,
        FormsModule,
        //TranslateModule,
        SharedModule,
        FileuploadModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatSortModule,
        FileSizeModule,
        MatDialogModule,
        MatIconModule,
        MatListModule,
        MatExpansionModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatGridListModule,
        WorkflowStepDriversManualModule,
        WorkflowStepAppAssetsModule,
        WorkflowStepDisclaimerModule,
        WorkflowHotspotCreatorModule
    ],
    entryComponents: [
        AcceptDeclineDialogComponent,
        MessageDialogComponent,
        SuccessMessageToastComponent,
        SuccessSaveToastComponent,
        SaveHotspotTemplateNoRowToastComponent
    ],
    providers: []
})
export class WorkflowModule {
}



